<template>
  <div class="modal-overlay-style banner-rf-promo relative">
    <div
      class="rfmodal-content rf-bannerpromo-wrapper rf-modal-content-wrapper"
      :style="bannerWrapperStyle"
    >
      <div ref="rfdim" class="rfmodal-wrapper inner-modal" :style="bannerBackgroundImage">
        <RfRetentionBanner
          :actions="actions"
          :isVideo="false"
          :hideButtons="hideButtons"
          :model="model"
        />
      </div>
      <div :style="containerBackgroundImage" class="rfmodal-backgroundimage"></div>
    </div>
  </div>
</template>

<script>
import RfRetentionBanner from "@/components/RfPathCreate/RfRetentionActions/components/RfRetentionBanner.vue";
import PromoPreviewMixin from "@/utils/PromoPreviewMixin";
import { getPositionStyle } from "@/utils/prompts/promptHelpers";
import { baseUrlReplacer } from "@/utils/BaseUrlReplacer";
import { useAppsStore } from "@/pinia/appsStore";
import { useLiquidContextStore } from "@/pinia/liquidContextStore";

export default {
  name: "RfRetentionBannerContent",
  components: { RfRetentionBanner },
  mixins: [PromoPreviewMixin],
  props: {
    actions: Object,
    deviceType: String,
    model: Object,
    zoomStyle: Object,
    zoomValue: Number,
    hideButtons: { type: Boolean, default: false },
  },
  setup: () => ({ appsStore: useAppsStore(), liquidContextStore: useLiquidContextStore() }),
  computed: {
    bannerBackgroundImage() {
      return {
        "background-color": this.actions.rf_settings_bg_image_color,
        "background-size": this.actions.rf_settings_tile_is_responsive,
        "background-image": this.actions.rf_settings_bg_image
          ? `url(${baseUrlReplacer(this.appsStore.app, this.liquidContextStore.liquidify(this.actions.rf_settings_bg_image))})`
          : "none",
      };
    },
    containerBackgroundImage() {
      const styles = {
        "background-color": this.actions.rf_settings_bg_image_color,
      };
      if (this.actions.rf_settings_bg_image) {
        styles["background-image"] =
          `url(${baseUrlReplacer(this.appsStore.app, this.liquidContextStore.liquidify(this.actions.rf_settings_bg_image))})`;
      } else {
        styles["background-image"] = "none";
      }
      return styles;
    },
    bannerWrapperStyle() {
      return {
        width: this.actions.rf_widget_width,
        height: this.actions.rf_widget_height,
        ...this.zoomStyle,
        ...this.bannerPositionStyle,
      };
    },
    bannerPositionStyle() {
      return getPositionStyle(this.actions, {
        offsetYKey: "rf_banner_position_offset_y",
        offsetXKey: "rf_banner_position_offset_x",
      });
    },
    overlayBackgroundColor() {
      return { background: this.actions.rf_settings_overlay_background };
    },
  },
};
</script>
